// FormFields/TextField.jsx
import React from 'react';
import { FormControl, FormLabel, Input, Button, Flex } from '@chakra-ui/react';

const TextField = ({ label, value, onChange, showTranslateButton, onTranslate,disabled, required, ...rest }) => (
  <FormControl mb={4}>
    <FormLabel>{label}{required && (<span style={{ color: 'red' }}>*</span>)}</FormLabel>
    <Flex align="center">
      <Input
        flex="1"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        {...rest}
      />
      {showTranslateButton && (
        <Button colorScheme="blue" ml={2} onClick={() => onTranslate(value)}>
          Translate
        </Button>
      )}
    </Flex>
  </FormControl>
);

export default TextField;